import { HttpApiError, HttpApiMiddleware } from "@effect/platform";
import { Context } from "effect";

/**
 * Parsed JSON payload from a verified Hookdeck webhook request.
 * Handlers should decode this with their specific schema.
 */
export class HookdeckPayload extends Context.Tag("HookdeckPayload")<
  HookdeckPayload,
  unknown
>() {}

/**
 * Verifies Hookdeck HMAC-SHA256 signature, parses body, provides via HookdeckPayload.
 * Endpoints using this should NOT use .setPayload() - body parsing happens here.
 */
export class HookdeckVerification extends HttpApiMiddleware.Tag<HookdeckVerification>()(
  "HookdeckVerification",
  { failure: HttpApiError.Unauthorized, provides: HookdeckPayload },
) {}
